/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface DatasetRow
 */
export interface DatasetRow {
  /**
   *
   * @type {number}
   * @memberof DatasetRow
   */
  key: number;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof DatasetRow
   */
  value: {[key: string]: string};
}

/**
 * Check if a given object implements the DatasetRow interface.
 */
export function instanceOfDatasetRow(value: object): value is DatasetRow {
  if (!('key' in value) || value['key'] === undefined) return false;
  if (!('value' in value) || value['value'] === undefined) return false;
  return true;
}

export function DatasetRowFromJSON(json: any): DatasetRow {
  return DatasetRowFromJSONTyped(json, false);
}

export function DatasetRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetRow {
  if (json == null) {
    return json;
  }
  return {
    key: json['key'],
    value: json['value']
  };
}

export function DatasetRowToJSON(value?: DatasetRow | null): any {
  if (value == null) {
    return value;
  }
  return {
    key: value['key'],
    value: value['value']
  };
}
